/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var _ = require('underscore');
var rootScope = require('../root-scope.service');
var networkServices = require('../networks.service');
var operateService = require('../operate.service');
const loadingService = require('../loading.service');
var operateCallback = operateService.operateCallback;

function removeNotAllowed(code, callback) {
    var presetAccount;
    var accounts;
    var networks;
    var selectedNetwork;
    if (!code) {
        return;
    }

    //remove preset account
    if (glob.presetAccount && glob.presetAccount.networkCode === code) {
        glob.presetAccount = null;
        $('.preset-account').remove();
    }

    //remove registered account
    rootScope.clientSideRemoveAccount(code);
    _.each(glob.accounts, function (value, index) {
        if (value.label.toLowerCase() === code.toLowerCase()) {
            $('#groupingregistered' + index).remove();
        }
    });

    //remove network
    rootScope.clientSideRemoveNetwork(code);
    $('.available-network#' + code).remove();

    //remove separators and labels
    selectedNetwork = rootScope.getSelectedNetwork();
    presetAccount = rootScope.getPresetAccount();
    accounts = rootScope.getAllAccounts();
    networks = rootScope.getAllNetworks();
    if ((_.isEmpty(accounts) && _.isEmpty(presetAccount)) || _.isEmpty(networks)) {
        $('.network-separator').remove();
    }
    if (_.isEmpty(accounts)) {
        $('.account-separator').remove();
    }

    //recheck network if network to hide is the selected one ( as presetAccount, network or registered account)
    if (
        !selectedNetwork ||
        selectedNetwork.code === code ||
        selectedNetwork.networkCode === code ||
        (selectedNetwork.label && selectedNetwork.label.toLowerCase() === code.toLowerCase())
    ) {
        networkServices.preCheckSelectedNetwork();
    }
    if (callback && typeof callback === 'function') {
        callback();
    }
}

function isNotAllowedNetwork(data) {
    return (
        data &&
        data.interaction &&
        data.interaction.code === 'TRY_OTHER_NETWORK' &&
        data.interaction.reason === 'CLIENTSIDE_ERROR' &&
        data.network
    );
}

function isAllowedNetwork(data) {
    return (
        data &&
        data.interaction &&
        data.interaction.code === 'PROCEED' &&
        data.interaction.reason === 'CLIENTSIDE_PAYMENT_POSSIBLE' &&
        data.network
    );
}

function hideOriginalSubmitButton() {
    rootScope.getSubmitButton().hide();
}

function showOriginalSubmitButton() {
    rootScope.getSubmitButton().show();
}

function availabilityNetworkHandler(data) {
    if (isNotAllowedNetwork(data)) {
        return removeNotAllowed(data.network, loadingService.handleLoadingOnProcessDone);
    }
    if (isAllowedNetwork(data)) {
        loadingService.handleLoadingOnProcessDone();
    }
}

function getSpecialPaymentButtonCase(formContainer) {
    var fieldSet = formContainer.find('fieldset');

    return fieldSet && fieldSet.attr('initcustomsubmitbtn');
}

function hasToWaitForAvailabilityCheck(formContainer) {
    var fieldSet = formContainer.find('fieldset');

    return fieldSet && fieldSet.attr('waitforavailabilitycheck') && fieldSet.attr('waitforavailabilitycheck') === 'true';
}

function getCurrentButtonClass(network) {
    var buttonsContainer = rootScope.getPayButtonContainer();

    return buttonsContainer + network.networkCode;
}

function toggleSpecialButton(network) {
    //hide All Other Special Buttons
    $('.' + rootScope.getSpecialButtonsClass()).hide();
    //show the one with givin network.code
    $('#' + getCurrentButtonClass(network)).show();
}

function showExactButton(formContainer, network) {
    var specialPaymentButtonCase = getSpecialPaymentButtonCase(formContainer);
    if (specialPaymentButtonCase) {
        hideOriginalSubmitButton();
    } else {
        showOriginalSubmitButton();
    }
    toggleSpecialButton(network);
}

function getSpecialButtonContainer(network) {
    var buttonsContainer = rootScope.getPayButtonContainer();
    var buttonsClass = rootScope.getSpecialButtonsClass();
    var currentButtonId = getCurrentButtonClass(network);
    if ($('#' + currentButtonId).length === 0) {
        var specialButtonContainer =
            '<div class="float-left ' + buttonsClass + '" id="' + currentButtonId + '" style="display:none"></div>';
        $('#' + buttonsContainer).prepend(specialButtonContainer);
    }

    return $('#' + currentButtonId)[0];
}

/**
 * A handler of special button on the standard page (payment page or first page).
 */
function specialButtonHandler(data) {
    if (isNotAllowedNetwork(data)) {
        return removeNotAllowed(data.network);
    }

    return operateCallback(null, data, null);
}

/**
 * Gets a handler for special button on the summary page.
 */
function getSpecialButtonSummaryPageHandler() {
    if (glob.summaryPageHandler) {
        return glob.summaryPageHandler;
    }

    return {
        doOperation: function (data, callBack) {
            $.ajax({
                type: data.method,
                dataType: 'json',
                data: JSON.stringify(data.operationData ? data.operationData : {}),
                contentType: 'application/json',
                url: data.url,
            }).done(callBack);
        },
        onResult: specialButtonHandler,
    };
}

function renderSpecialButton(formContainer, network, isPreload) {
    var specialPaymentButtonCase = getSpecialPaymentButtonCase(formContainer);
    if (!specialPaymentButtonCase) {
        return;
    }
    if (glob.summaryPage) {
        var operationUrl = glob.presetAccount ? glob.presetAccount.links.operation : null;
        eval(specialPaymentButtonCase)(
            network,
            getSpecialButtonContainer(network),
            getSpecialButtonSummaryPageHandler(),
            operationUrl,
            glob.listResponse
        );
    } else {
        if (isPreload && !hasToWaitForAvailabilityCheck(formContainer)) {
            loadingService.handleLoadingOnProcessDone();
        }
        eval(specialPaymentButtonCase)(
            network,
            getSpecialButtonContainer(network),
            isPreload ? availabilityNetworkHandler : specialButtonHandler,
            undefined,
            glob.listResponse
        );
    }
    if (isPreload) {
        formContainer.find('fieldset').remove();
    }
}

function handleSpecialButton(formContainer, network, isPreload) {
    renderSpecialButton(formContainer, network, isPreload);
    if (!isPreload) {
        showExactButton(formContainer, network);
    }
}

module.exports = {
    getSpecialButtonContainer: getSpecialButtonContainer,
    showExactButton: showExactButton,
    toggleSpecialButton: toggleSpecialButton,
    getCurrentButtonClass: getCurrentButtonClass,
    getSpecialPaymentButtonCase: getSpecialPaymentButtonCase,
    showOriginalSubmitButton: showOriginalSubmitButton,
    hideOriginalSubmitButton: hideOriginalSubmitButton,
    renderSpecialButton: renderSpecialButton,
    handleSpecialButton: handleSpecialButton,
    removeNotAllowed: removeNotAllowed,
};
